const gray = {
  0: '#ffffff',
  50: '#fafaf9',
  150: '#f7f7f7',
  200: '#f6f7f8',
  250: '#f5f5f5',
  300: '#f4f4f4',
  400: '#ebeff2',
  450: '#ecebea',
  500: '#dfdfdf',
  550: '#c9c7c5',
  725: '#a1afb5',
  850: '#969492',
  950: '#81929b',
  975: '#777777',
  1025: '#706e6b',
  1050: '#687982',
  1200: '#3e3e3c',
  1250: '#333333',
  1300: '#1F1F1F',
  1350: '#121212',
  1400: '#22262a',
} as const;

const blue = {
  100: '#e5f0fc',
  150: '#ebf2f7',
  200: '#d5e6f1',
  221: '#f3f8fc',
  400: '#bfd9fc',
  500: '#9bcbeb',
  650: '#74b8ff',
  700: '#5cb3ea',
  750: '#4a90e2',
  800: '#3a72b5',
  900: '#1f93db',
  925: '#1f6bb1',
  930: '#1f74ba',
  990: '#1a4985',
  1025: '#004eae',
  1030: '#3653d5',
  1040: '#2d46b5',
  1075: '#1f599e',
} as const;

const green = {
  50: '#e8f5ea',
  75: '#e5f7e5',
  100: '#c3e7c8',
  200: '#add7ad',
  400: '#67de6f',
  500: '#5ac402',
  700: '#2bab83',
  750: '#118819',
  850: '#00b045',
  900: '#008e38',
  950: '#116611',
} as const;

const yellow = {
  50: '#fffad7',
  150: '#fff3e2',
  175: '#fcf3e0',
  200: '#ffe4a0',
  300: '#f5dbb5',
  400: '#f5a623',
  500: '#f29d50',
  650: '#eaa111',
  700: '#c67d00',
  750: '#ffee00',
  900: '#422006',
} as const;

const red = {
  50: '#fcebee',
  100: '#f4d2d0',
  200: '#ef7d5b',
  250: '#ff6e6e',
  400: '#da6561',
  500: '#dc3b3b',
  600: '#eb1515',
  700: '#d70015',
  750: '#c45353',
  800: '#b91818',
  900: '#330000',
} as const;

const orange = {
  500: '#ff8000',
  600: '#f1635f',
} as const;

const pink = {
  200: '#ff3e7a',
} as const;

const purple = {
  100: '#9b91c5',
  300: '#7d6fc4',
} as const;

const teal = {
  100: '#79d5e0',
  400: '#088391',
  500: '#08a2b5',
} as const;

const overlay = {
  blackAlpha: {
    12: '#0000001f',
    20: '#00000033',
    50: '#00000080',
  },
  blueAlpha: {
    3: '#0064ab08',
  },
  white: {
    10: '#FFFFFF1A',
    20: '#FFFFFF33',
    50: '#FFFFFF80',
  },
  black: {
    10: '#0000001A',
    20: '#00000033',
  },
} as const;

export default {
  gray,
  blue,
  green,
  yellow,
  red,
  orange,
  pink,
  purple,
  teal,
  overlay,
  blueberry: {
    100: '#496ed8',
    70: '#89a0e6',
    50: '#b7c4f0',
  },
  gold: {
    100: '#eac563',
    30: '#f9efd4',
  },
  jadeite: {
    100: '#62b59e',
  },
} as const;
